import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap, tap } from 'rxjs/operators';

import * as landingActions from './landing.actions';
import { Router } from '@angular/router';
import { ProfilePicturesService } from '@app/shared/profile-pictures.service';

@Injectable()
export class LandingEffects {
  selectParent$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(landingActions.selectParent),
        tap(() => this.router.navigateByUrl('/parent-home')),
      ),
    { dispatch: false },
  );

  loadProfilePictures$ = createEffect(() =>
    this.actions$.pipe(
      ofType(landingActions.loadProfilePictures),
      mergeMap(({ studentIds }) =>
        this.profilePicturesService
          .getProfilePictures(studentIds)
          .pipe(
            map((profilePictures) =>
              landingActions.loadProfilePicturesSuccess({ profilePictures }),
            ),
          ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private router: Router,
    private profilePicturesService: ProfilePicturesService,
  ) {}
}
